import asyncActionType from "../../utils/asyncActionType";

export const FETCH_OFFERS = asyncActionType("FETCH_OFFERS");

export const FETCH_INVENTORY = asyncActionType("FETCH_INVENTORY");
export const DELETE_INVENTORY = asyncActionType("DELETE_INVENTORY");
export const UPDATE_INVENTORY = asyncActionType("UPDATE_INVENTORY");
export const CREATE_TEMPERATURE = asyncActionType("CREATE_TEMPERATURE");
export const ADD_TEMPERATURE_TO_INVENTORY = "ADD_TEMPERATURE_TO_INVENTORY";

export const FETCH_ITEMS = asyncActionType("FETCH_ITEMS");
export const FETCH_BRANDS = asyncActionType("FETCH_BRANDS");
export const FETCH_GRADES = asyncActionType("FETCH_GRADES");
export const FETCH_WASTE_CATEGORIES = asyncActionType("FETCH_WASTE_CATEGORIES");
export const FETCH_LOCATIONS = asyncActionType("FETCH_LOCATIONS");

export const FETCH_AUDITS = asyncActionType("FETCH_AUDITS");
export const CREATE_AUDIT = asyncActionType("CREATE_AUDIT");
export const FETCH_AUDIT = asyncActionType("FETCH_AUDIT");
export const ADD_AUDIT_INVENTORY = asyncActionType("ADD_AUDIT_INVENTORY");
export const REMOVE_AUDIT_INVENTORY = asyncActionType("REMOVE_AUDIT_INVENTORY");
export const CSV_SUBMIT = asyncActionType("CSV_SUBMIT");

export const FETCH_INVENTORIES_RECALL =asyncActionType("FETCH_INVENTORIES_RECALL");